import { render, staticRenderFns } from "./SelectSeat.vue?vue&type=template&id=1520ef39&scoped=true&"
import script from "./SelectSeat.vue?vue&type=script&lang=js&"
export * from "./SelectSeat.vue?vue&type=script&lang=js&"
import style0 from "./SelectSeat.vue?vue&type=style&index=0&id=1520ef39&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1520ef39",
  null
  
)

export default component.exports